import { Box, Typography } from "@mui/material";
import { Styled } from "./styles";
import { useUpdateStatus } from "@/hooks/misc/useUpdates";

const UpdatesModal: React.FC = () => {
    const { newVersion, canceled, setCanceled } = useUpdateStatus();

    const onCancel = () => {
        setCanceled(true);
        setTimeout(() => setCanceled(false), 60000 * 10);
    };

    return (
        <Styled.Modal open={newVersion && !canceled}>
            <Styled.Content>
                <Box display="flex" flexDirection="column">
                    <Typography variant="h3" textAlign="center" margin="10px 0px">
                        New update available
                    </Typography>
                    <Typography variant="body1" textAlign="center">
                        Please reload the page to see new updates. You might experience problems
                        using portal if you don't update to the latest version.
                    </Typography>
                </Box>
                <Box display="flex" flexDirection="row" alignItems="center" margin="20px 0px">
                    <Styled.Button
                        type="button"
                        variant="outlined"
                        color="error"
                        onClick={onCancel}
                    >
                        Cancel
                    </Styled.Button>
                    <Styled.Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={() => window.location.reload()}
                    >
                        Reload
                    </Styled.Button>
                </Box>
            </Styled.Content>
        </Styled.Modal>
    );
};

export default UpdatesModal;
